import tw, { styled } from 'twin.macro';

const Subheading = styled.h2`
  ${tw`m-0 font-normal text-xl`}
`;

export default Subheading;
